// change-stream.ts
import { Change } from "@adornis/base/change.js";
import { map, scan } from "rxjs";
function changeStream(obs) {
  return obs.pipe(
    scan((both, curr) => [...both, curr].slice(-2), []),
    map(([oldObject, newObject]) => Change.getDiff(oldObject, newObject))
  );
}
export {
  changeStream
};
